export default defineNuxtPlugin((nuxtApp) => {
  const gtmId = useRuntimeConfig().public.GTM_ID;
  let isGtmLoaded = false;

  const loadGtm = () => {
    if (isGtmLoaded) return;
    isGtmLoaded = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const existingScript = document.querySelector(`script[src^="https://www.googletagmanager.com/gtm.js?id=${gtmId}"]`);
    if (existingScript) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
  };

  nuxtApp.hook('app:mounted', () => {
    const loadAfterTab = (event: KeyboardEvent) => {
      if (event.key !== 'Tab') return;
      loadGtm();
      window.removeEventListener('keydown', loadAfterTab);
    };

    // Keep GTM out of the initial critical path; it starts on the first
    // intentional visit interaction instead.
    window.addEventListener('scroll', loadGtm, { once: true, passive: true });
    window.addEventListener('mousemove', loadGtm, { once: true, passive: true });
    window.addEventListener('touchstart', loadGtm, { once: true, passive: true });
    window.addEventListener('keydown', loadAfterTab);
  });
});
